import $ from 'jquery';
var curWinWidth = $(window).prop('innerWidth');
const adapt = 768;
$.fn.getData = function(name,defaultValue){
    if(typeof this.data(name) !== 'undefined'){
        return this.data(name);
    }else{
        if(typeof defaultValue !== 'undefined'){
            return defaultValue;
        }else{
            return undefined;
        }
    }
};
$.fn.dropdownMenu = function(options){
    var defaultConfig = {
        trigger: '.cdz-trigger',
        dropdown: '.cdz-dropdown-content',
        exceptClass: null,
        hideAffterClick: false
    };
    var conf = $.extend({},defaultConfig,options);
    return this.each(function(){
        var $cont = $(this);
        if(conf.exceptClass != null){
            if($cont.hasClass(conf.exceptClass)){
                return false;
            }
        }
        var $trigger = $cont.find(conf.trigger);
        var $dropdown = $cont.find(conf.dropdown);
        $trigger.addClass('dd-trigger');
        $dropdown.addClass('dd-content');
        $trigger.click(function(e){
            e.stopPropagation();
            if(!$cont.hasClass('dd-open')){
                if($('.dd-open').length > 0){
                    var $ddopen = $('.dd-open');
                    $ddopen.find('.dd-trigger').removeClass('active');
                    $ddopen.find('.dd-content').slideUp();
                    $ddopen.removeClass('dd-open');
                }
            }
            $cont.toggleClass('dd-open');
            $trigger.toggleClass('active');
            $dropdown.slideToggle();
        });
        $('html, body').on('click', function(e){
            var $target = $(e.target);
            if( ($target.parents('.dd-open').first().length == 0) || conf.hideAffterClick){
                $cont.find(conf.dropdown).slideUp();
                $cont.find(conf.trigger).removeClass('active');
                $cont.removeClass('dd-open');
            }
        });
    });
}
window.checkoutChangeSection = function(sectionId){
    var $section = $('#'+sectionId);
    $('.step-edit',$section).click();
}
function checkoutProgressBar(){
    if($('body').attr('id') == 'checkout'){
        var html = '<div class="col-md-12">';
        html +=     '<div class="row block block-progress opc-block-progress">';
        html +=         '<div class="block-title"><strong><span></span></strong></div>';
        html +=         '<div class="block-content"><dl>';
        
        var stepPosition = 1;
        var firstStepId = '';
        $('.checkout-step').each(function(){
            var $this = $(this);
            var stepId = $this.attr('id');
            if(stepPosition == 1){
                firstStepId = stepId;
            }
            stepPosition++;
            var title = '<div>'+$('.step-title',$this).html()+'</div>';
            var $title = $(title);
            $title.find('.material-icons').remove();
            $title.find('.step-number').remove();
            $title.find('.step-edit').wrap('<a href="javascript:void(0)" onclick="checkoutChangeSection(\''+stepId+'\')"></a>');
            var complete = $this.hasClass('-complete')?'complete':'';
            html +=         '<div class="step-item" id="item-'+stepId+'"><dt class="'+complete+'">'+$title.html()+'</dt></div>'
        });
        html +=         '</dl></div>';
        html +=     '</div>';
        html += '</div>';
        var $progressBar = $(html);
        var $container = $('#'+firstStepId).parent().parent();
        $progressBar.insertBefore($container);
    }
}
function viewCheckoutDetail(){
    if( $('.checkout-summary-container.content-inner').length > 0 ){
        var $checkoutCont = $('.checkout-summary-container.content-inner').first();
        $checkoutCont.click(function(e){
            if(!$checkoutCont.hasClass('show')){
                $checkoutCont.addClass('show');
                $('#content').addClass('checkout-detail-shown');
            }else{
                if($(e.target).parents('.checkout-summary-container').length == 0){
                    $checkoutCont.removeClass('show');
                    $('#content').removeClass('checkout-detail-shown');
                }
            }
        });
    }
}
function cdzSlider(){
    $('.cdz-slider').each(function(){
        var $owl = $(this);
        $owl.addClass('owl-carousel owl-theme');
        $owl.owlCarousel({
            loop: $owl.data('loop')?$owl.data('loop'):false,
            margin: $owl.getData('margin',10),
            responsiveClass: true,
            nav: $owl.getData('nav',true),
            dots: $owl.getData('dots',false),
            autoplay: $owl.getData('autoplay',false),
            responsive:{
                0:{items:   $owl.getData('items_0',1)},
                320:{items: $owl.getData('items_320',3)},
                480:{items: $owl.getData('items_480',4)},
                768:{items: $owl.getData('items_768',5)},
                980:{items: $owl.getData('items_980',7)},
                1280:{items: $owl.getData('items_1280',7)}
            },
            rtl: (!!window.codazon.enable_rtl)
        })
    });
}
function changeAdapt(adaptWidth){
    if(typeof adaptWidth === 'undefined'){
        adaptWidth = 768;
    }
    var curWinWidth = $(window).prop('innerWidth');
    $(window).resize(function(){
        setTimeout(function(){
            var winWidth = $(window).prop('innerWidth');
            if( (curWinWidth < adaptWidth) && (winWidth >= adaptWidth) ){
                if(adaptWidth == 768){
                    $(window).trigger('cdz_pc');
                }else{
                    $(window).trigger('cdz_pc_' + adaptWidth);          
                }
            }else if( (curWinWidth >= adaptWidth) && (winWidth < adaptWidth)){
                if(adaptWidth == 768){
                    $(window).trigger('cdz_mobile');
                }else{
                    $(window).trigger('cdz_mobile_' + adaptWidth);
                }
            }
            curWinWidth = winWidth;
        },200);
    });
}
function mobileConfig(){
    function mobileTabs(){
        $('.mobile-nav-tab-dropdown').each(function(){
            var target = $(this).data('target');
            $(target).addClass('mobile-nav-tabs');
        }); 
    }
    function mobileFooter(){
        $('.cdz-toggle-title').each(function(){
            var $title = $(this);
            if( $title.data('cdz-toggle') != ''){
                var $content = $($title.data('cdz-toggle'));
                $content.hide();
                $title.click(function(){
                    if( !$title.hasClass('active') ){
                        $('.cdz-toggle-title.active').click();
                    }
                    $title.toggleClass('active');
                    $content.slideToggle();
                });
            }
        });
    }
    mobileTabs();
    mobileFooter();
}
function pcConfig(){
    function pcTabs(){
        $('.mobile-nav-tabs').removeClass('mobile-nav-tabs');   
    }
    function pcFooter(){
        $('.cdz-toggle-title').each(function(){
            var $title = $(this);
            if( $title.data('cdz-toggle') != ''){
                var $content = $($title.data('cdz-toggle'));
                $content.show();
                $title.unbind('click');
                $title.removeClass('active');
            }
        });
    }
    pcTabs();
    pcFooter();
}
function responsiveTabs(){
    $('.nav-tab-item a').click(function(){
        var $navTab = $(this);
        var $dropdown = $navTab.parent().parent().parent().find('.mobile-nav-tab-dropdown');
        var tabTitle = $navTab.text();
        $dropdown.text(tabTitle);
        $navTab.parents('.mobile-nav-tabs').first().removeClass('active');
    });
    $('.mobile-nav-tab-dropdown').click(function(){
        var $navTab = $(this);
        var target = $navTab.data('target');
        var $target = $(target);
        $target.toggleClass('active');
    });
    $('body').click(function(e){
        if(!$(e.target).hasClass('mobile-nav-tab-dropdown')){
            $('.mobile-nav-tabs').removeClass('active');
        }
    });
}
function backToTop(){
    $('[data-role="back_top"]').each(function(){
        var $bt = $(this);
        $bt.click(function(e){
            e.preventDefault();
            $('html, body').animate({'scrollTop':0},800);
        });
        function toggleButton(hide){
            if(hide){
                $bt.fadeOut(300);
            }else{
                $bt.fadeIn(300);
            }
        }
        var hide = ($(window).scrollTop() < 100);
        toggleButton(hide);
        $(window).scroll(function(){
            var newState = ($(window).scrollTop() < 100);
            if(newState != hide){
                hide = newState;
                toggleButton(hide);
            }
        });
    });
}
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return "";
}
function cookiePopup(){
    $('[data-role="cookie_popup"]').each(function(){
        var $popup = $(this),
        config = $popup.data('config');
        if(typeof config.expireTime === 'undefined'){
            config.expireTime = 60*60*1000;
        }
        var now = new Date(),
        time = now.getTime(),
        expireTime = time + config.expireTime;
        
        now.setTime(expireTime);
        if(!getCookie("cdz_popup")){
            document.cookie = 'cdz_popup=true; expires='+now.toGMTString();
            $popup.modal('show');
        } 
    });
}
function fieldLabelEffect(){
    var uniqId = Math.round(Math.random()*100000);
    var list = '.form-group input[type="text"],.form-group input[type="password"],.form-group input[type="email"],.form-group select';
    $('.form-group .form-control-label').each(function(){
        var $label = $(this);
        if($label.html().trim() != ''){
            var $parent = $label.parents('.form-group').first();
            //$parent.addClass('label-effect active');
            if($parent.find('input').length > 0){
                var $input = $parent.find('input').first();
                $label.addClass('label-' + $input.attr('type') + '-' + $input.attr('name'));
            }
        }
    });
    
    $(list).each(function(){
        var $input = $(this);
        if(!$input.attr('id')){
            if($input.attr('name')){
                var inputId = $input.attr('name').replace('[','').replace(']','') + '_' + uniqId;
            }else{
                var inputId = 'id_' + Math.round(Math.random()*100000);
            }
            $input.attr('id',inputId);
        }
        var $parent = $input.parents('.form-group').first();
        $parent.addClass('label-effect');
        var $label = $('label',$parent);
        if($label.length > 0){
            $label.each(function(){
                var $lb = $(this);
                if(typeof $lb.attr('for') !== 'string'){
                    $lb.attr('for',$input.attr('id'));
                }
            });
        }
        if( $input.andSelf()[0].outerHTML.search('placeholder') > -1){
            $label.addClass('always-active');
        }
        if( $input.prop('tagName').toLowerCase() == 'select' ){
            $label.addClass('always-active');
        }
        if($input.val() != ''){
            $parent.addClass('active'); 
        }else{
            $parent.removeClass('active');
        }
        
        $input.focus(function () {
            $parent.addClass('active');
        }).blur(function() {
            if($input.val() == ''){
                $parent.removeClass('active');
            }
        });
        var checkBrowserFilled = function(){
            if($input.val() != ''){
                $parent.addClass('active');
                $input.off('change.checkbrowserfilled');
            }
        };
        $input.on('change.checkbrowserfilled',checkBrowserFilled);
        $label.click(function(){
            $input.focus();
        });
    });
};
function toggleMobileMenu() {
    $('[data-role=menu-title]').each(function() {
        var $title = $(this),
        $menu = $title.parent().find('[data-role=menu-content]');
        $menu.removeClass('hidden-sm-down');
        var onMobile = function() {
            $menu.hide();
        }
        var onDesktop = function() {
            $menu.css({display: ''});
        }
        var toggle = function() {
            if (window.innerWidth < adapt) {
                onMobile();
            } else {
                onDesktop();
            }
        }
        $title.on('click', function() {
            if (window.innerWidth < adapt) {
                $menu.slideToggle(200);
            }
        });
        $(window).on('cdz_mobile', function() {
            onMobile();
        }).on('cdz_pc', function(){
            onDesktop();
        });
        toggle();
    });
}
$(document).ready(function(e) {
    checkoutProgressBar();
    cdzSlider();
    responsiveTabs();
    changeAdapt(adapt);
    viewCheckoutDetail();
    backToTop();
    cookiePopup();
    fieldLabelEffect();
    toggleMobileMenu();
    if(curWinWidth < adapt){
        mobileConfig();
    }else{
        pcConfig();
    }
    $(window).on('cdz_mobile',mobileConfig);
    $(window).on('cdz_pc',pcConfig);
    $('.cdz-dropdown').dropdownMenu({trigger:'.cdz-trigger', dropdown:'.cdz-dropdown-content'});
});


// WEBPACK FOOTER //
// ./js/fastest.js